export default function useValidator() {
    return {
        email: function(data) {
            const valid=!!String(data).toLowerCase().match(/^\S+@\S+\.\S+$/)
            return [valid,valid?[]:[`Please enter a valid email address.`]]
        },
        password: function(data) {
            const errors=[]
            if(data.length<8) errors.push('Password must be at least 8 characters.')
            if(data.search(/[a-z]/i)<0) errors.push('Password must contain at least one letter.')
            if(data.search(/[0-9]/)<0) errors.push('Password must contain at least one digit.')
            return [errors.length===0, errors]
        },
        // i18n name support: allow Unicode letters, hyphens, apostrophes, spaces
        firstName: function(data) {
            const valid=!!String(data).match(/^[\p{L}\p{M}'\-\s]+$/u)
            return [valid, valid?[]:['Please enter a valid first name.']]
        },
        url: function(data) {
            try {
                new URL(data)
                return [true,[]]
            } catch {
                return [false,['Please enter a valid URL.']]
            }
        }
    }
}
